import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  return {
    areaTitle: {
      fontSize: '12px',
      color: colors.color10,
      display: 'flex',
      alignItems: 'center'
    },
    viewMore: {
      fontSize: '1rem',
      color: colors.color16,
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    titlesTab: {
      height: '100%',
      alignContent: 'center',
      fontSize: '20px',
      fontWeight: '500',
      marginBottom: '20px'
    }
  }
}

export { useStyles }
